// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__LAYOt","noInteraction":"EventWrapper_noInteraction__kVNEW"};